export default __webpack_public_path__ + "static/media/SampleTemplate.f40ad8d8.xlsx";